import { render, staticRenderFns } from "./Shop.vue?vue&type=template&id=f54c8d84&scoped=true&"
import script from "./Shop.vue?vue&type=script&lang=js&"
export * from "./Shop.vue?vue&type=script&lang=js&"
import style0 from "./Shop.vue?vue&type=style&index=0&id=f54c8d84&prod&lang=css&"
import style1 from "./Shop.vue?vue&type=style&index=1&id=f54c8d84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54c8d84",
  null
  
)

export default component.exports